import React from 'react';

function CancellationFollowupsSkeleton({ count = 6 }) {
    return (
        <div className="table-responsive cancellation-followups-table-wrap">
            <table className="table align-middle mb-0 cancellation-followups-table cancellation-followups-skeleton-table">
                <thead>
                    <tr>
                        <th>Patient</th>
                        <th>Email</th>
                        <th>Cell Phone</th>
                        <th>Home Phone</th>
                        <th>Missed Appointment</th>
                        <th>Email</th>
                        <th>SMS</th>
                        <th>Call</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: count }).map((_, index) => (
                        <tr key={`cancellation-followups-skeleton-${index}`}>
                            <td><div className="cancellation-followups-skeleton__line cancellation-followups-skeleton__line--medium" /></td>
                            <td><div className="cancellation-followups-skeleton__line cancellation-followups-skeleton__line--long" /></td>
                            <td><div className="cancellation-followups-skeleton__line cancellation-followups-skeleton__line--short" /></td>
                            <td><div className="cancellation-followups-skeleton__line cancellation-followups-skeleton__line--short" /></td>
                            <td><div className="cancellation-followups-skeleton__line cancellation-followups-skeleton__line--medium" /></td>
                            <td><div className="cancellation-followups-skeleton__box" /></td>
                            <td><div className="cancellation-followups-skeleton__box" /></td>
                            <td><div className="cancellation-followups-skeleton__box" /></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default CancellationFollowupsSkeleton;
